var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-search',[_c('router-link',{attrs:{"to":{path:'add'}}},[_c('a-button',{staticStyle:{"float":"right","margin-top":"8px"},attrs:{"type":"primary"}},[_vm._v("新增")])],1),_vm._v("域名列表 ")],1),_c('v-tablelist')],1)}
var staticRenderFns = []

export { render, staticRenderFns }